import React from 'react'

type Props = {
    children: React.ReactNode
}

const Body = (props: Props) => {
    return (
        <div className="body">
            {props.children}
        </div>
    )
}

export default Body